import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import { typedMemo } from '@utils';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useBreadcrumb } from './breadcrumbHooks';

export const DynamicBreadcrumbs = typedMemo(() => {
  const { t } = useTranslation();
  const { segments } = useBreadcrumb();

  return (
    <Breadcrumbs
      sx={{
        padding: '0.9rem 0 0.9rem 1rem',
        position: 'fixed',
        top: '4rem',
        backgroundColor: 'rgb(241, 241, 241)',
        width: '100%',
        zIndex: 1000,
      }}
      separator={<ChevronRightOutlined />}
    >
      <Link to="/" style={{ display: 'flex' }}>
        <HomeOutlined />
      </Link>
      <Typography>{t('app.mainPageTitle')}</Typography>
      {segments
        .filter((segment) => segment.title && segment.title.trim() !== '')
        .map((segment) =>
          segment.href ? (
            <Link key={segment.id} to={segment.href}>
              <Typography>{segment.title}</Typography>
            </Link>
          ) : (
            <Typography key={segment.id}>{segment.title}</Typography>
          ),
        )}
    </Breadcrumbs>
  );
});
